import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import '../solution.scss';
import AppImage from '../../../common/features/image';

function AdSection({
  title,
  subtitle,
  description,
  imageSrc,
  imageAlt,
  bulletPoints = [],
  imagePosition = 'left',
  firstCol = '',
  secondCol = '',
}) {

  const [part1, part2] = title.split(' ');

  const imageColumn = imagePosition === 'left' ? (
    <Col md={7} sm={12} className={`solution-rightside-img ${secondCol}`}>
      <AppImage src={imageSrc} alt={imageAlt} title={imageAlt} className={`img-style`} />
    </Col>
  ) : (
    <Col md={7} sm={12} className='solution-leftside-img'>
      <AppImage src={imageSrc} alt={imageAlt} title={imageAlt} className={`img-style`} />
    </Col>
  );

  const bulletList = bulletPoints.length > 0 && (
    <ul className="custom-bullets">
      {bulletPoints.map((point, index) => (
        <li key={index} className="pt-1">{point}</li>
      ))}
    </ul>
  );

  return (
    <section className="section-2">
      <Row>
        <Col md={5} sm={12} className={`${firstCol}`}>
          <div className={`${imagePosition === 'left' ? 'sol-section-left-column' : 'sol-section-right-column' }`}>
            <div className="common-section-content"><span className='energy-purple'>{part1}</span> {part2}</div>
            <div className="subTitle-content">{subtitle}</div>
            <div className="common-subsection-content">{description}</div>
            {bulletList}
          </div>
        </Col>
        {imageColumn}
      </Row>
    </section>
  );
}

AdSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  bulletPoints: PropTypes.arrayOf(PropTypes.string),
  imagePosition: PropTypes.oneOf(['left', 'right']),
  firstCol: PropTypes.string.isRequired,
  secondCol: PropTypes.string.isRequired,
};

export default AdSection;
